import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";

function Home() {
  const options = {
    items: 1,
    loop: true,
    autoplay: true,
     autoplayTimeout: 3000,
    animateOut: "slideOutRight",
    nav: false,
    dots: true,
    margin: 0,
    
     
    responsive: {
      1100: {
        items: 1,
      },
      724: {
        items: 1,
      },
      500: {
        items: 1,
      },
      370: {
        items: 1,
        innerWidth: "100%",
        outerWidth: "100%",
      },
    },
  };

  return (
    <>
    <Helmet>
    <meta charset="utf-8" />
    <title>Eagle Eye Enterprises</title>
    <link
          rel="canonical"
          href="https://eagleeyeenterprises.co.in/"
        />
     <meta name="description" content="Eagle Eye Enterprises CCTV security services CCTV cameras are one of the important elements in securing our businesses and daily lives. We provide design and installation of end-to-end CCTV security systems right from cameras (both analog & IP) to network to NVR's to server/storage to power backup solution to monitoring solution etc. We also provide wireless camera solutions; we have everything you need to customize your business security. We provide Best Performance Surveillance Security Systems at competitive price"/>
    <meta name="keywords" content="eagle eye enterprises EEE, Kankarbhagh, Patna"/>
    </Helmet>
      <OwlCarousel className="owl-theme" {...options}   >
        {/* <div class="item" >
           
            <img src="assets/img/carousel-1.jpg" alt="img1" />
           
        </div> */}
        <div class="item" >
           
            <img src="assets/img/carousel-2.jpg" alt="img2" />
           
        </div>
        <div class="item">
           
            <img src="assets/img/carousel-3.jpg" alt="img3" />
           
        </div>
          
         <div class="item">
          <h4>
            <img src="assets/img/bio2.jpg" alt="img4" />
          </h4>
        </div>
         
        <div class="item">
          <h4>
            <img src="assets/img/gps-tracker.jpg" alt="img5" />
          </h4>
        </div>
        {/* <div class="item">
          <h4>
            <img src="assets/img/intercom.jpeg" alt="img6" />
          </h4>
        </div> */}
        <div class="item">
          <h4>
            <img src="assets/img/bio1.jpg" alt="img7" />
          </h4>
        </div>  
      </OwlCarousel>

    <div className="container-xxl py-4 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container">
        
      <div className="testimonial-item text-center">
        <p className="fs-5" style={{color: '#000000', fontFamily:'Palatino Linotype',fontWeight:'600'}}>Are you planning for commercial security camera installation to protect your business or commercial property? Would you like to see your entire property at a glance from your smartphone and even stop crime before it happens?
        Welcome to the world of video surveillance and security camera solutions. <span style={{color: '#0c406b', fontFamily:'sans-serif'}}>Welcome to the Eagle Eye Enterprises</span></p>
       </div>
            
  </div>
</div>

    
 
 {/* <!-- Service Start --> */}
 <div className="container-xxl py-3">
  <div className="container">
    <div className="text-center">
      <div className="bg-primary mb-2 mx-auto" style={{width: 60, height: 2}} />
      <h1 className="display-5 mb-2">Our Services</h1>
      <div className="bg-primary mb-2 mx-auto" style={{width: 60, height: 2}} />
    </div>
     
    <div className="container-xxl py-2">
  <div className="container">
    <div className="row g-4">
      <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.1s" >
        <div className="h-100  p-4 p-xl-5" style={{backgroundImage: 'linear-gradient(to bottom right, #001628,#5eb4f9)'} }>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="btn-square rounded-circle" style={{width: 64, height: 64, background: '#000000'}}>
              <img className="img-fluid" src="assets/img/icon/icon-6.png" alt="Icon" />
            </div>
            <h5 className="text-white" style={{marginLeft:'18px'}}> Commercial CCTV System</h5>
          </div>
          
          <span style={{color:'#ffffff'}}>Commercial CCTV systems are today more sophisticated than ever.A whole host of features are available to enhance the functionality and integration to your business.</span>
          <Link className="btn" to="/service" style={{color:'#2f4be3' }}><i className="fa fa-arrow-right text-brown me-3" />Read More</Link>
        </div>
      </div>
      <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.3s">
        <div className="h-100 p-4 p-xl-5" style={{backgroundImage: 'linear-gradient(to bottom right, #001628,#5eb4f9)'} }>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="btn-square rounded-circle" style={{width: 64, height: 64, background: '#000000'}}>
              <img className="img-fluid" src="assets/img/icon/icon-8.png" alt="Icon" />
            </div>
            <h5 className="mb-0 text-white" style={{marginLeft:'18px'}}>Biometric Sensor</h5>
          </div>
                    <span style={{color:'#ffffff'}}>It only requires a user-facing camera and has been built with the user at the heart of our design principles.</span>
                    <Link className="btn" to="/service" style={{color:'#2f4be3' }}><i className="fa fa-arrow-right text-brown me-3" />Read More</Link>
        </div>
      </div>
      <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.5s">
        <div className="h-100 p-4 p-xl-5" style={{backgroundImage: 'linear-gradient(to bottom right, #001628,#5eb4f9)'} }>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="btn-square rounded-circle" style={{width: 64, height: 64, background: '#000000'}}>
              <img className="img-fluid"  src="assets/img/icon/icon-3.png" alt="Icon" />
            </div>
            <h5 className="mb-0 text-white" style={{marginLeft:'18px'}}>Smart Home Security</h5>
          </div>
           
          <span style={{color:'#ffffff'}}>Our organization is counted among the recognized names engaged in providing Home & Office Security. These services are rendered by the expert, who undertake every possible step to ensure the safety of home and office.</span>
          <Link className="btn" to="/service" style={{color:'#2f4be3'}}><i className="fa fa-arrow-right text-brown me-3" />Read More</Link>
        </div>
      </div>
    </div>
  </div>
</div>


  </div>
</div>

    {/* <!-- Service End --> */}


           <div className="container-fluid bg-success overflow-hidden my-5 px-lg-0">
        <div className="container feature px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div
              className="col-lg-6 feature-text py-5 wow fadeIn"
              data-wow-delay="0.5s"
            >
              <div className="p-lg-5 ps-lg-0">
                <div
                  className="bg-primary mb-3"
                  style={{ width: 60, height: 2 }}
                />
                <h1 className="display-5 mb-5">Why Choose Us</h1>
                <p className="text-white mb-4 pb-2">
                  Our first priority is our valuable clients. We want to do business with honesty and integrity to sustain longer in market.
                </p>
                <div className="row g-4">
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div
                        className="btn-square bg-white rounded-circle"
                        style={{ width: 64, height: 64 }}
                      >
                        <img
                          className="img-fluid"
                          src="assets/img/icon/icon-7.png"
                          alt="Icon"
                        />
                      </div>
                      <div className="ms-4">
                        <p className="text-warning mb-2">Trusted</p>
                        <h5 className="mb-0">Security</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div
                        className="btn-square bg-white rounded-circle"
                        style={{ width: 64, height: 64 }}
                      >
                        <img
                          className="img-fluid"
                          src="assets/img/icon/icon-10.png"
                          alt="Icon"
                        />
                      </div>
                      <div className="ms-4">
                        <p className="text-warning mb-2">Quality</p>
                        <h5 className="mb-0">Services</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div
                        className="btn-square bg-white rounded-circle"
                        style={{ width: 64, height: 64 }}
                      >
                        <img
                          className="img-fluid"
                          src="assets/img/icon/icon-3.png"
                          alt="Icon"
                        />
                      </div>
                      <div className="ms-4">
                        <p className="text-warning mb-2">Smart</p>
                        <h5 className="mb-0">Systems</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div
                        className="btn-square bg-white rounded-circle"
                        style={{ width: 64, height: 64 }}
                      >
                        <img
                          className="img-fluid"
                          src="assets/img/icon/icon-2.png"
                          alt="Icon"
                        />
                      </div>
                      <div className="ms-4">
                        <p className="text-warning mb-2">12/7 Hours</p>
                        <h5 className="mb-0">Support</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 pe-lg-0" style={{ minHeight: 400 }}>
              <div className="position-relative h-100">
                <img
                  className="position-absolute img-fluid w-100 h-100"
                  src="assets/img/feature.jpg"
                  style={{ objectFit: "cover" }}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
     
        </>
  );
}

export default Home;
